const { CARD_INTERVENTION_OWNER } = require('constants/index');
const { CUSTOM_ACCOUNTS } = require("constants/expensesByCategories/filters");

const filterOwnVisibleCards = (immCards, typeAccount = CUSTOM_ACCOUNTS) => {
    const immCreditCards = immCards.get('credit');

    return immCreditCards.get('byOrder').filter((cardId) => {
        const immCard = immCards.getIn(['byId', cardId]);

        if (typeAccount === CUSTOM_ACCOUNTS) {
            return immCard.getIn(['filters', 'valid']) &&
            immCard.get('type') === 'credit' &&
            immCard.get('interventionType') === CARD_INTERVENTION_OWNER;
        } else {
            return immCard.get('type') === 'credit' &&
            immCard.get('interventionType') === CARD_INTERVENTION_OWNER;
        }
    })
}

const getNumberCard = (immCards, immCreditCards, typeAccount = CUSTOM_ACCOUNTS) => {
    return filterOwnVisibleCards(immCards, typeAccount).map((cardId) => {
        const immCard = immCreditCards.getIn(['byId', cardId]);

        return immCard.get('number');
    }).toJS()
}

module.exports = {
    filterOwnVisibleCards,
    getNumberCard
};